import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LoggerService } from '@app/blocks/logger/services/logger.service';
import moment from 'moment';

@Injectable({
    providedIn: 'root'
})
export class SignupTransformsService {

    constructor(private logger: LoggerService) { }

    getNextOfKinTransform(response: HttpResponse<any>): any {
        let nextOfKin;

        if (response.status === 200) { // success
            nextOfKin = response.body;
            return nextOfKin;
        } else if (response.status === 404) { // not found
            nextOfKin = {};
            return nextOfKin;
        } else {
            return null;
        }
    }

    getAdditionalDetailsTransform(response: HttpResponse<any>): any {
        let details;

        if (response.status === 200) { // success
            details = response.body; //angular.fromJson(data);

            this.logger.info('getAdditionaletailsTransform after Json parsing', details);

            return details;
        } else if (response.status === 404) { // not found
            details = {};
            return details;
        } else {
            return null;
        }
    }

    // postAdditionalDetailsTransform(formData: any) {
    //     formData = JSON.parse(JSON.stringify(formData)); //angular.toJson(formData);
    //     return formData;
    // }

    postNextOfKinTransform(formData: any) {
        formData = JSON.parse(formData);
        return formData;
    }

    // Prevent date from losing a day when going from GMT to UTC
    processDate(dateToProcess: any) {
        this.logger.info('processDate date in', dateToProcess);

        if (moment(dateToProcess).format('H') === '23' || moment(dateToProcess).format('H') === '0') {
            const utcDate = moment(dateToProcess).add(1, 'h');
            dateToProcess = utcDate.format("YYYY-MM-DDTHH:mm:ss[Z]");
        }

        this.logger.info('processDate date out', dateToProcess);

        return dateToProcess;
    }
}
